


































































import { Vue, Component, Prop } from "vue-property-decorator";
import Axios from "axios";
import MD5 from "crypto-js/md5";
import "flag-icon-css/css/flag-icon.min.css";

@Component
export default class Avatar extends Vue {
  public $refs!: {
    fileUpload: HTMLFormElement;
  };

  @Prop({ default: null })
  public src!: string;

  @Prop({ default: null })
  public name!: string;

  @Prop({ default: "" })
  public email!: string;

  @Prop({ default: "user-alt" })
  public icon!: string;

  @Prop({ default: false })
  public clickable!: boolean;

  @Prop({ default: false })
  public uploadable!: boolean;

  @Prop({ default: false })
  public hasDropdown!: boolean;

  @Prop({ default: false })
  public isPulsing!: boolean;

  @Prop({ default: 100 })
  public size!: number;

  @Prop({ default: false })
  public loading!: boolean;

  @Prop({ default: "GB" })
  public locationCountryCode!: string;

  public gravatar = "";

  public created() {
    if (this.src || !this.email) return;
    this.checkForGravatar();
  }

  public get initials() {
    const name = this.name.trim().split(" ");

    if (name.length > 1) {
      const first = this.$_.first(this.$_.first(name)) || "";
      const last = this.$_.first(this.$_.last(name)) || "";
      return `${first + last}`.toUpperCase();
    }

    return name[0].substring(0, 2).toUpperCase();
  }

  public onClick() {
    if (this.loading || this.uploadable) {
      return;
    }

    if (this.clickable) {
      this.$emit("click");
    }
    return;
  }

  public onFileChanged(event) {
    this.$emit("file-changed", this.$_.get(event, "target.files[0]", {}));
    this.$refs.fileUpload.value = "";
  }

  public onDelete() {
    this.$emit("file-delete");
  }

  public async checkForGravatar() {
    const hash = MD5(this.email).toString();
    const url = `https://gravatar.com/avatar/${hash}?d=404&s=200`;

    try {
      await Axios.get(url);
      this.gravatar = url;
    } catch (err) {
      // no gravatar
    }
  }
}
